<template>
  <BaseModal :title="$t('Attached files')">
    <FilesTable :files="context.files" />
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';
  import FilesTable from '@/containers/tender/tender-info/files-table/FilesTable';
  import { mapState } from 'vuex';

  export default {
    name: 'AttachedFilesModal',
    components: {
      BaseModal,
      FilesTable,
    },
    computed: {
      ...mapState('modal', ['context']),
    },
  };
</script>
